module.exports = __webpack_public_path__ + "static/media/financial_report.5b7e6379.png";